
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Dienstort from '@/types/Dienstort';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { VForm } from '@/types/Components';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';
    import _ from 'lodash';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('dienstorte', ['dienstorte', 'loaders', 'printers']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('dienstorte', ['updateDienstort', 'deleteDienstort', 'loadPrinters']),
        },
    })
    export default class DienstorteDetail extends Vue {
        @Prop() dienstort!: Dienstort;
        @Prop() visible!: boolean;

        public updateDienstort!: (dienstort: Dienstort) => void;
        public deleteDienstort!: (dienstort: Dienstort) => void;
        public loadPrinters!: () => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;
        public dienstorte: any;

        public $refs!: {
            form: VForm;
        };

        public get isEdit(): boolean {
            return this.dienstort.dienstort_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateDienstort(this.dienstort);
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Dienstort endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteDienstort(this.dienstort);
                    }
                });
        }

        get dienstorteFiltered() {
            var retval:any [] = [];
            _.forEach(this.dienstorte, (item: Dienstort) => {
                if (item.dienstort_id !== this.dienstort.dienstort_id) {
                    retval.push(item);
                }
            });

            return retval;
        }
    }
